export default __webpack_public_path__ + "static/media/B0001.abd6b9cb.png";